import React, { useRef } from 'react';
import { useDrag } from 'react-dnd';

const Card = (props) => {
  const { index, cardType, originalItem } = props;
  const ref = useRef(null);
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'card', index, cardType, originalItem },
    collect: (monitor) => {
      return {
        isDragging: monitor.isDragging(),
      };
    },
  });
  drag(ref);
  return (
    <li ref={ref} className="dd-item">
      <div className="dd-handle">
        <i className="fe-align-justify" /> {originalItem.title}
      </div>
    </li>
  );
};
export default Card;
